import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import WhatsAppButton from '@/components/feature/WhatsAppButton';
import useSeo from '@/hooks/useSeo';
import { ASSETS } from '@/constants/assets';
import HeroSection from './components/HeroSection';
import PorqueSection from './components/PorqueSection';
import AreasSection from './components/AreasSection';
import EquipeSection from './components/EquipeSection';
import FormularioSection from './components/FormularioSection';
import MensagemSection from './components/MensagemSection';

export default function TrabalheConosco() {
  useSeo({
    title: 'Trabalhe Conosco | Pilar Manutenção Industrial',
    description: 'Cadastre seu currículo e faça parte da equipe da Pilar. Oportunidades para profissionais da área industrial, mecânica e hidráulica.',
    keywords: 'trabalhe conosco, vagas industriais, emprego mecânica, emprego hidráulica, carreira Pilar, Aracruz, ES',
    canonical: 'https://www.pilarmanutencao.com.br/trabalhe-conosco',
    ogUrl: 'https://www.pilarmanutencao.com.br/trabalhe-conosco',
    ogImage: ASSETS.logoPilar,
  });

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  return (
    <div className="min-h-screen bg-gp-graphite">
      <Navbar />
      <main>
        <HeroSection />
        <PorqueSection />
        <AreasSection />
        <EquipeSection />
        <FormularioSection />
        <MensagemSection />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}